import { capitalize } from "lodash";

import { getDisplayPrompt } from "@/utils/getDisplayPrompt";

import { Typography } from "../../components/ui-v2";
import { SelectedObject } from "./types";

const getHeaderText = (objects: SelectedObject[]) => {
  if (objects.length > 1) {
    return `${objects.length} items selected`;
  } else if (objects.length === 1) {
    const singleObj = objects[0];
    const type = capitalize(singleObj.__typename);
    const defaultTitle = `Selected ${type}`;

    if (singleObj.__typename === "File") {
      const filePrompt = getDisplayPrompt(singleObj.inferenceParameters);
      return filePrompt
        ? capitalize(filePrompt)
        : singleObj.name ?? defaultTitle;
    }

    return singleObj.name ?? defaultTitle;
  }

  return "Selected Item";
};

interface SelectionSidebarHeaderTitleProps {
  objects: SelectedObject[];
}

export const SelectionSidebarHeaderTitle = (
  props: SelectionSidebarHeaderTitleProps,
) => {
  const { objects } = props;
  const headerText = getHeaderText(objects);

  return (
    <Typography
      noWrap
      title={headerText}
      sx={{
        fontWeight: 600,
      }}
      variant="small"
    >
      {headerText}
    </Typography>
  );
};
